export default __webpack_public_path__ + "static/media/sidebar-icon-3.7963c5e2.svg";